export const createCheckoutApis = instance => ({
  getMember: ()=> instance.get('/member/get'),
  getLogistics: ()=> instance.get('/mall/logisticsManagement/front/shippingFee/list'),
  getReceiverList: () =>instance.get('/mall/shoppingCart/receiverInfo/list'),
  checkout: data=>instance.post('/mall/orders/distributorCheckout', data),
  completionInfo: params=>instance.get('/mall/orders/completionInfo', {params}),
})
